<template>
    <section class="content">
      <box>
        <div slot="body">
            <div class="categorias" v-for="(c, index) in categorias">
              <div class="row">
                <div class="col-md-6">
                  <h4>Nome</h4>
                  <input v-model="c.nome" type="text" class="form-control" >
                </div>
                <div class="col-md-6">
                  <h4>Imagem </h4>
                  <input type="file" :id="`file-input-${index}`" class="form-control">
                  <p id="status">Please select a file</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <h4>Habilita multiplo sabor (Pizza)</h4>
                  <toggle-button 
                    v-model="c.permitemeia"
                    :color="color" 
                    :sync="true" />
                </div>
                <div class="col-md-2">
                  <h4>Categoria de Produtos Adicionais</h4>
                  <toggle-button 
                    v-model="c.adicionais"
                    :color="color" 
                    :sync="true" />
                </div>  
                <div class="col-md-2" style="    padding: 0.7em;">
                  <a @click="removerCategoria(index)"><i class="fa fa-times" aria-hidden="true"></i></a>
                </div>  
              </div>
              <br>
              <hr>
              <br>
            </div>
            
            <div class="row">
                <div class="col-sm-12 adicionaVoo" style="text-align: center">
                    <a @click="adicionarCategoria"><i class="fa fa-plus-circle" aria-hidden="true">Adicionar Categoria</i></a>
                </div>
            </div>

            <br><br>
            <router-link class="pageLink" to="/categorias">
                    <button class="btn btn-danger" >Cancelar</button>
            </router-link>
            <button class="btn btn-success" @click="gravar" v-show="nome!='' && !gravando"><i class="fa fa-check"></i>  Gravar</button>
            <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
        </div>
    </box>
        
    </section>
</template>
<script>
import axios from 'axios'
import Box from '../Box' // importando modal
import s3 from '../../../services/s3'
import { setTimeout } from 'timers';

export default {
  name: 'NovaCategoria',
  components: {
    'box': Box
  },
  data () {
    return {
      categorias: [{
        nome: '',
        permitemeia: false,
        adicionais: false,
        imagem: ''
      }],
      categoria_pai: null,
      subnivel: false,
      gravando: false,
      editar: false,
      ativo: true,
      erro: false
    }
  },
  created () {
    if(this.$route.params.id) {
      this.getCategoriaById(this.$route.params.id)
      this.editar = true
    }
  },
  methods: {
    gravar () {
      this.gravando = true
      let files = this.categorias.map((element, index) => document.getElementById(`file-input-${index}`).files[0] );
      files = files.filter(function (el) {
        return el != null && el != undefined;
      });
      console.log('files => ', files)
      if(files.length > 0 ) {
        files.forEach((file, index) => {
          var blob = file.slice(0, file.size, file.type); 
          let newFile = new File([blob], `${this.$store.state.empresa_id}_categoria_${Date.now()}_${file.name}`, {type: file.type});
          s3.getSignedRequest(newFile).then(res => {
            this.categorias[index].imagem = res.url;
          }).catch(err => {
            console.log('erro => ', err);
            this.erro = true;
            alert('Erro ao salvar imagem');
          })
        });
      }

      setTimeout(() => {
        if(!this.erro) {
          this.gravarCategoria();
        }
      }, files.length * 1500)
    },
    removerCategoria(index) {
      this.categorias.splice(index, 1)
    },
    gravarCategoria(){
      this.categorias.forEach(categoria => {
        axios.post(this.$store.state.api+'categorias/insert', {
          'nome': categoria.nome,
          //'pai': categoria.categoria_pai,
          'imagem': categoria.imagem,
          'alteracao': false,
          'id_categoria': this.$route.params.id,
          'permitemeia' : categoria.permitemeia,
          'adicionais' : categoria.adicionais,
          'ativo': true,
          'empresa': this.$store.state.empresa_fb_id
        }).then(response => {
          if (!response.data.success) {
            this.erro = true
          }
        })
        
        setTimeout(() => {
          if(this.erro) {
            this.$swal(
              'Ops!',
              'A categoria não foi gravada.',
              'error'
            )
          } else {
              this.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Criada com sucesso',
                showConfirmButton: false,
                timer: 1500
              })   
              this.$router.push('categorias');
          }
        }, this.categorias.length * 2000);
      });
    },
    adicionarCategoria() {
        this.categorias.push({
            nome: '',
            permitemeia: false,
            adicionais: false,
        })
    },
    getCategoriaById (id) {
      axios.get(this.$store.state.api + 'categorias/' + id).then((response) => {
        console.log('categorias -> ', response.data)
        this.nome = response.data.nome,
        this.imagem = response.data.url_imagem
        this.permitemeia = response.data.permitemeia
        this.adicionais = response.data.adicionais
        this.ativo = response.data.ativo
      }) 
    }
  }
}
</script>
<style scoped>
hr { 
  display: block;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  margin-left: auto;
  margin-right: auto;
  border-style: inset;
  border-width: 1px;
}
</style>




// WEBPACK FOOTER //
// InclusaoRapidaCategorias.vue?42c48707